/** Credit/debit report item type */
export enum CreditDebitReportTypeEnum {
  /** Credit report */
  CREDIT = 'credit',
  /** Debit report */
  DEBIT = 'debit',
  /** Debtors report */
  DEBTORS = 'debtors',
}
